module.exports = __webpack_public_path__ + "5ef928645103768b4bb28cac0fd51833.pdf";